import { render, staticRenderFns } from "./CoursesDetail.vue?vue&type=template&id=2dc9e4a0"
import script from "./CoursesDetail.vue?vue&type=script&lang=js"
export * from "./CoursesDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports